module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1021I5C/tc-custom/9781526749727.jpg?1707506116484",
      "alt": "This image is the cover for the book Last Years of the London Titan"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Years of the London Titan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The author of "), _c('i', [_vm._v("The London Bendy Bus")]), _vm._v(" memorializes the end of the Leyland Titan era in “a must for all London bus fans of the 1980s” (West Somerset Railway Association).")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Already depleted by withdrawals in the London Buses Ltd era, the Leyland Titan fleet of T class was divided upon privatization between three new companies: London Central, Stagecoach East London and Stagecoach Selkent. Together with a host of smaller companies operating secondhand acquisitions, the Titans’ declining years between 1998 and 2003 are explored in this pictorial account that encompasses both standard day-to-day routes, emergency deployments and rail replacement services. Only small numbers remained to usher out the type altogether at the end of 2005, when step-entrance double-deckers as a whole were banished from the capital."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “[A] magnificent portrait of the time through an interesting collection of images.” —"), _c('i', [_vm._v("Miniaturas JM")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Matthew Wharmby\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Matthew Wharmby is an author, photographer and editor who specializes in London bus history.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword/Pen and Sword Transport\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0